import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';

const BulkDeleteTasksModal = ({ isOpen, onClose, onConfirm, tasks, loading }) => {
  if (!isOpen || !tasks || tasks.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Delete Tasks</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
            Are you sure you want to delete {tasks.length} task{tasks.length > 1 ? 's' : ''}? This action cannot be undone.
          </p>
          <div className="bulk-document-list">
            {tasks.slice(0, 5).map(task => (
              <div key={task.taskId} className="bulk-document-item">
                <div className="bulk-document-name">{task.patient?.name || 'Unknown Patient'}</div>
                <div className="bulk-document-assignee">{task.text}</div>
              </div>
            ))}
            {tasks.length > 5 && (
              <div className="bulk-document-more">
                ... and {tasks.length - 5} more task{tasks.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#e74c3c', fontSize: '14px', fontWeight: '600' }}>
            All selected tasks will be permanently removed from the system.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="task-submit-button" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <FontAwesomeIcon icon={faSpinner} spin />
            ) : (
              'Delete All Tasks'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkDeleteTasksModal;
